export function getManualTestTodoDisplayTitle({
  testKeyRef,
  testTitle,
  manualTestName = '',
}: {
  testKeyRef: string;
  testTitle: string;
  manualTestName?: string;
}) {
  const displayTitle = `${testKeyRef} - ${testTitle}`;

  return manualTestName ? `${displayTitle} (${manualTestName})` : displayTitle;
}
